import { useNavigate } from 'react-router-dom'

// antd
import { Typography, theme } from 'antd'

// components
import Button from '../../components/button/button'

// assets
import { LinkExpireIcon } from '../../assets/icons'

// constants
import { PUBLIC_ROUTES } from '../../routes'

function LinkExpired() {
    const { useToken } = theme

    const navigate = useNavigate()

    const { token } = useToken()

    const { Text } = Typography

    return (
        <div
            style={{
                padding: '60px 60px 0px 60px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <LinkExpireIcon />
            <div
                style={{
                    margin: '35px 0px 40px 0px',
                    textAlign: 'center',
                }}
            >
                <Text
                    className="titleLight"
                    style={{
                        fontSize: token.fontSizeHeading5,
                    }}
                >
                    Your set password link has been expired.
                </Text>
            </div>
            <Button
                props={{
                    text: 'Login',
                    onClick: () => navigate(PUBLIC_ROUTES.login),
                    style: {
                        backgroundColor:
                            token.colorPalette.registrationColor.secondary,
                        width: '100%',
                    },
                }}
            />
        </div>
    )
}

export default LinkExpired
